import { render, staticRenderFns } from "./OBApproval.vue?vue&type=template&id=972db886&"
import script from "./OBApproval.vue?vue&type=script&lang=js&"
export * from "./OBApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports